import '@/i18n';
import { useEffect, useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import CookieBanner from '@/components/CookieBanner';
import ScrollToTop from '@/components/ScrollToTop';
import Home from '@/pages/Home';
import ThankYou from '@/pages/ThankYou';
import LegalPage from '@/pages/LegalPage';
import { getLangFromPath, SUPPORTED_LANGS } from '@/lib/langRouter';

function LangSync() {
  const location = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    const lang = getLangFromPath(location.pathname);
    if (i18n.language !== lang) i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    // Update <title> and <meta description>
    const title = i18n.getFixedT(lang)('meta.title');
    const desc = i18n.getFixedT(lang)('meta.description');
    if (title) document.title = title;
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    if (desc) metaDesc.setAttribute('content', desc);
  }, [location.pathname, i18n]);
  return null;
}

function LangRoutes() {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="privacy" element={<LegalPage ns="privacy" />} />
      <Route path="cookies" element={<LegalPage ns="cookiepol" />} />
      <Route path="terms" element={<LegalPage ns="terms" />} />
    </Routes>
  );
}

function AppShell() {
  const [forceCookies, setForceCookies] = useState(0);
  return (
    <>
      <ScrollToTop />
      <LangSync />
      <Header />
      <Routes>
        <Route path="/" element={<Navigate to="/hr" replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        {SUPPORTED_LANGS.map((code) => (
          <Route key={code} path={`/${code}/*`} element={<LangRoutes />} />
        ))}
        <Route path="*" element={<Navigate to="/hr" replace />} />
      </Routes>
      <Footer onOpenCookies={() => setForceCookies((n) => n + 1)} />
      <CookieBanner forceOpen={forceCookies} />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

export default App;
